import React, { useState, useEffect } from "react";
import Overviewbar from "./Overviewbar";
import "../cssfiles/homepage.css";
import { Box, CssBaseline, Stack, TextField } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import SearchConfig from "./CommonComponents/SearchConfig";
import OrganisationSetting from "./ConfigPages/OrganisationSetting";
import Organizationtree from "./Organizationtree";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AddOrganizationconf from "./ConfigPages/AddOrganizationconf";
import Userdisplay from "./ConfigPages/Userdisplay";
import Adduser from "./ConfigPages/Adduser";
import OrganisationList from "./ConfigPages/AdminDashboard/OrganizationList";
import { apiService } from "../Restclient/datacollection";
import { getorganizationtree } from "../Restclient/datacollection";
import { setOrganizationtree, setSelectedTreeNode } from "../store/cofig_data";
// import { fetchOrganizationTree } from "../actions/organizationActions"; // Import the new action
import RoleAccessManagement from "./ConfigPages/UserAccessManangement/RoleManagementView.js";
import RolesManagement from "./ConfigPages/UserAccessManangement/RoleManagement.js";
import LoginPolicySettings from "./ConfigPages/UserAccessManangement/LoginPolicySettings.jsx";
import { Breadcrumb } from "antd";
import CustomDialogBox from "./CommonComponents/CustomDialogBox.jsx";
import Template from "./Reports/Template.js";
import TemplateGroup from "./Reports/TemplateGroup.js";

// Helper to strip base64 from Logo for localStorage
const stripBase64ForStorage = (nodeData) => {
  if (!nodeData || typeof nodeData !== "object") return nodeData;

  if (Array.isArray(nodeData)) {
    return nodeData.map((item) => stripBase64ForStorage(item));
  }

  const strippedNode = { ...nodeData };

  // Remove base64 from Logo but keep dimensions
  if (strippedNode.Logo && typeof strippedNode.Logo === "object") {
    strippedNode.Logo = {
      height: strippedNode.Logo.height,
      width: strippedNode.Logo.width,
    };
  }

  // Process children recursively
  if (
    Array.isArray(strippedNode.children) &&
    strippedNode.children.length > 0
  ) {
    strippedNode.children = strippedNode.children.map((child) =>
      stripBase64ForStorage(child)
    );
  }

  return strippedNode;
};

export default function UserConfiguration() {
  const selectedTreeItem = useSelector(
    (state) => state.configdata.selectedTreeItem
  );
  const overviewstate = useSelector(
    (state) => state.mainpagedata.overviewbarstate
  );
  const dispatch = useDispatch();
  const [pagesize, setPagesize] = useState(168);
  const [maintabs, setMaintabs] = useState(["Organization List"]);
  const [tabvalue, setTabvalue] = useState("Organization List");
  const [addneworg, setAddneworg] = useState(false);
  const [saveorgdata, setSaveorgdata] = useState(false);
  const [orgaddedit, setOrgaddedit] = useState();
  const [sidetabtext, setSidetabtext] = useState("Add Organization");
  const [treeselect, setTreeselect] = useState({});
  const [adduserfalg, setAdduserflag] = useState(false);
  const [sidetabtextuser, setSidetabtextuser] = useState(
    "Add Organization User"
  );
  const [saveuserdata, setSaveuserdata] = useState(false);
  const [usereditconf, setUsereditconf] = useState({});
  const [userorgname, setUserorgname] = useState("");
  const [userprojname, setUserprojname] = useState("");
  const [addnewuser, setAddnewuser] = useState(false);
  const [orgTree, setOrgTree] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const [brdCumbPath, setBrdCrumbPath] = useState([]);
  const [alertState, setAlertState] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const {
    User_Role_ID,
    Organizationid,
    Projectlist,
    PermissionsArray: userPermissions,
  } = useSelector((state) => state.logindata.userdetails);
  const fetchOrganizationTree = (updatedata) => {
    setIsLoading(true);
    return async (dispatch) => {
      try {
        if (updatedata == null) {
          if (
            userdetails?.User_Role_Details?.Name == "EA_ADMIN" ||
            userdetails?.User_Role_Details?.Name == "ORGANIZATION_ADMIN"
          ) {
            const response = await apiService.getTreeData(Organizationid);
            console.log("option 1 response-fetchOrganizationTree", response);
            dispatch(setOrganizationtree(response?.data?.treejson));
            setOrgTree(response?.data?.treejson);
          } else {
            console.log(
              "Projectlist-fetchOrganizationTree",
              Projectlist,
              "Organizationid",
              Organizationid
            );
            const response = await apiService.getTreeDataDirectLinkage(
              Projectlist[0],
              Organizationid
            );
            console.log("option 3 response-fetchOrganizationTree", response);
            dispatch(setOrganizationtree(response?.data?.treejson));
            setOrgTree(response?.data?.treejson);
          }

          // }
          // else{
          //     const response = await apiService.getTreeByOrganizationId(Organizationid);
          //     dispatch(setOrganizationtree(response?.data?.treejson));
          //     setOrgTree(response?.data?.treejson)
          //     // debugger
          //     // dispatch(setOrganizationtree(updatedata));
          // }
          // const transformed =[{
          //     id:"root",
          //     label:"Organization List",
          //     children:response?.data?.treejson
          // }]
          // setOrganizationtree(transformed)
        }
      } catch (error) {
        console.error("Error fetching organization tree:", error);
      } finally {
        setIsLoading(false);
      }
    };
  };

  useEffect(() => {
    dispatch(fetchOrganizationTree()); // Use the new action to fetch organization tree
  }, []);
  useEffect(() => {
    // console.log("overviewstate ", overviewstate)
    if (overviewstate) {
      setPagesize(160);
    } else {
      setPagesize(316);
    }
  }, [overviewstate]);

  const handleAddnewOrg = () => {
    // console.log("handleAddnewOrg ", treeselect)
    if (treeselect.type === "none") {
      setOrgaddedit({
        orgdata: {
          type: "Organization",
          orgname: "",
        },
        request: "add",
      });
      setSidetabtext("Add Organization");
      setAddneworg(true);
    } else if (treeselect.type === "Organization") {
      setOrgaddedit({
        orgdata: {
          type: "Project",
          orgname: treeselect.data.Organizationname,
        },
        request: "add",
      });
      setSidetabtext("Add Project");
      setAddneworg(true);
    } else {
      setOrgaddedit({
        orgdata: {
          type: "Organization",
          orgname: "",
        },
        request: "add",
      });
      setSidetabtext("Add Organization");
      setAddneworg(true);
    }
  };

  const handleAddnewOrgUser = () => {
    // console.log("Add user",treeselect, treeselect.type)

    if (treeselect.type === "Organization") {
      setUsereditconf({
        data: {
          type: "Organization",
          orgpro: treeselect,
        },
        request: "add",
      });
      setSidetabtextuser("Add Organization User");
      setAddnewuser(true);
    } else if (treeselect.type === "Project") {
      setUsereditconf({
        data: {
          type: "Project",
          orgpro: treeselect,
        },
        request: "add",
      });
      setSidetabtextuser("Add Project User");
      setAddnewuser(true);
    }

    setAdduserflag(true);
    //setSidetabtextuser()
  };

  const handleLoading = (val) => {
    setIsLoading(val);
  };
  const handlecloseadduser = () => {
    setAdduserflag(false);
    setSaveuserdata(false);
    setAddnewuser(false);
  };

  const handlecloseaddnew = () => {
    setAddneworg(false);
  };

  const handlesaveorg = () => {
    setSaveorgdata(true);
  };

  const handlesavecallback = () => {
    setSaveorgdata(false);
  };

  const handleusersavecallback = () => {
    setSaveuserdata(false);
  };

  const callbackeditorganization = (org) => {
    //console.log("org ",org)
    if (org.type === "Organization") {
      setOrgaddedit({
        request: "edit",
        orgdata: org,
      });
      setSidetabtext("Modify Organization");
      setAddneworg(true);
    } else if (org.type === "Project") {
      setOrgaddedit({
        request: "edit",
        orgdata: org,
      });
      setSidetabtext("Modify Project");
      setAddneworg(true);
    }
  };

  const callbackedituser = (user) => {
    console.log("edit user ", user);
    if (treeselect.type === "Organization") {
      setUsereditconf({
        data: {
          type: "Organization",
          orgpro: treeselect,
          userdata: user,
        },
        request: "edit",
      });
      setAdduserflag(true);
      setSidetabtextuser("Modify Organization User");
      setAddnewuser(true);
    } else if (treeselect.type === "Project") {
      setUsereditconf({
        data: {
          type: "Project",
          orgpro: treeselect,
          userdata: user,
        },
        request: "edit",
      });
      setAdduserflag(true);
      setSidetabtextuser("Modify Project User");
      setAddnewuser(true);
    }
  };

  const handletreeselectcallback = (slectedtreedata) => {
    if (!slectedtreedata) {
      return;
    }
    setTreeselect(slectedtreedata); // Store full data in state (with base64)
    const { id, type, Type } = slectedtreedata;
    const nodeType = type || Type;

    // Strip base64 before storing to localStorage to avoid quota error
    const strippedForStorage = stripBase64ForStorage(slectedtreedata);
    try {
      localStorage.setItem(
        "selectedTreeNode",
        JSON.stringify(strippedForStorage)
      );
    } catch (e) {
      console.warn("Failed to save to localStorage:", e);
    }

    dispatch(setSelectedTreeNode(slectedtreedata)); // Store full data in Redux

    if (nodeType === "rootOrg") {
      if (userdetails?.User_Role_Details?.Name == "EA_ADMIN") {
        setMaintabs([
          "Organization List",
          "Login Policy Settings",
          "Template Group",
          "Template",
        ]);
        setTabvalue(
          "Organization List",
          "Login Policy Settings",
          "Template Group",
          "Template"
        );
      } else {
        setMaintabs(["Organization List"]);
        setTabvalue("Organization List");
      }
    } else if (
      slectedtreedata?.Type?.toLowerCase() === "organization" ||
      slectedtreedata?.Type?.toLowerCase() === "sub-organization"
    ) {
      setMaintabs(["Organization Details", "Users List", "Roles Management"]);
      setTabvalue("Organization Details", "Users List", "Roles Management");
    } else if (slectedtreedata?.Type?.toLowerCase() === "project") {
      // if(userdetails?.User_Role_Details?.Name == "EA_ADMIN"){
      //     setMaintabs(['Project Details']);
      //     setTabvalue('Project Details');
      // }else{
      setMaintabs(["Project Details", "Users List", "Roles Management"]);
      setTabvalue("Project Details", "Users List", "Roles Management");
      //}
    }
  };

  const handleTreePath = (treePath) => {
    setBrdCrumbPath(treePath);
  };

  const handleAddNode = async (parentId, newNode) => {
    if (parentId == "") {
      alert("parent id is empty");
      return;
    }

    const type = newNode?.Type?.toLowerCase();

    if (type === "organization" || type === "sub-organization") {
      const res = await apiService.addorganization(parentId, newNode);
      if (res?.status === "done") {
        if (res?.result?.success === false) {
          setAlertState({
            show: true,
            message: res?.result?.message,
            type: "Error",
            confirmText: "OK",
          });
        } else {
          dispatch(fetchOrganizationTree());
        }
      }
    }

    if (type === "project") {
      const res = await apiService.addProject(parentId, newNode);
      if (res?.status === "done") {
        dispatch(fetchOrganizationTree());
      } else {
        setAlertState({
          show: true,
          message: "Eror while adding project",
          type: "Error",
          confirmText: "OK",
        });
      }
    }
  };

  //Organization Level
  const handleDeleteNode = async (currentNode) => {
    if (
      currentNode?.Type?.toLowerCase() === "organization" ||
      currentNode?.Type?.toLowerCase() === "sub-organization"
    ) {
      const orgId = currentNode?.Organizationid;
      const orgName = currentNode?.Organizationname;
      const res = await apiService.deleteOrganization(orgName, orgId);
      if (res.status === "done") {
        dispatch(fetchOrganizationTree());
      }
    } else if (currentNode?.Type?.toLowerCase() === "project") {
      const projectId = currentNode?.ProjectId;
      const Projectname = currentNode?.Projectname;
      const res = await apiService.deleteProject(projectId, Projectname);
      if (res.status === "done") {
        dispatch(fetchOrganizationTree());
      }
    }
    //    const res = await apiService.deleteProject(projectId);
    //    if(res.status === "done"){
    //     dispatch(fetchOrganizationTree());
    //    }

    // const deleteNodeRecurrsively =(nodes)=>{
    //     return nodes?.filter((node)=> node.id !== nodeId)
    //     .map((node)=>({
    //         ...node,
    //         children:node.children
    //         ?deleteNodeRecurrsively(node.children)
    //         :[]
    //     }));
    // }
    // let updatedData = deleteNodeRecurrsively(organizationtree);
    // console.log("updatedData",updatedData)
    // // dispatch(setOrganizationtree(updatedData));
    // setTreeselect(updatedData);
    // if(selectedTreeItem?.id === nodeId)
    //     setTreeselect(null);
  };
  const handleUpdateNode = async (nodeId, updatedNode) => {
    if (
      updatedNode?.Type?.toLowerCase() === "organization" ||
      updatedNode?.Type?.toLowerCase() === "sub-organization"
    ) {
      const orgId = nodeId;
      const res = await apiService.editOrganization(orgId, updatedNode);

      if (res && res.status === "done") {
        // dispatch(setOrganizationtree(res?.data?.treejson));
        // setOrgTree(res?.data?.treejson)
        dispatch(fetchOrganizationTree());
        dispatch(setOrganizationtree(res?.data?.treejson));
      }
    } else if (updatedNode?.Type?.toLowerCase() === "project") {
      const projectId = updatedNode?.ProjectId;

      const res = await apiService.editProject(projectId, updatedNode);
      if (res && res.status === "done") {
        dispatch(fetchOrganizationTree());
        // dispatch(setOrganizationtree(res?.data?.treejson));
      }
    }
    // const editNodeRecurrsively = (nodes)=>{
    //     return nodes?.map((node)=>{
    //         if(node?.id == nodeId){
    //             return {...node,...updatedNode}
    //         }
    //         if(node?.children){
    //             return {...node,children:editNodeRecurrsively(node?.children)}
    //         }
    //         return node;
    //     })
    // }

    // let updatedData = (editNodeRecurrsively(organizationtree));
    // // dispatch(setOrganizationtree(updatedData));
    // setTreeselect(updatedData)
  };

  const handletabchange = (event, newValue) => {
    console.log("newValue ", newValue);
    setTabvalue(newValue);
  };

  const handlesaveusertrigger = () => {
    setSaveuserdata(true);
  };
  const tabPermissionMap = {
    "Users List": "USCR06",
    "Roles Management": "RLAC09",
    "Login Policy Settings": "LGPC08",
  };
  return (
    <Box
      className="configuration"
      style={{
        height: "calc(100vh - 60px)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginRight: "18px",
          paddingTop: "10px",
          marginBottom: "10px",
        }}
      >
        <div
          className="breadcrumb-config"
          style={{ flexGrow: 1, marginRight: "4px", marginLeft: "16px" }}
        >
          {Array.isArray(brdCumbPath) ? (
            brdCumbPath.length > 0 && (
              <Breadcrumb>
                <Typography
                  className="crumbs-config"
                  style={{
                    fontSize: "14px",
                    fontWeight: 400,
                    paddingTop: "10px",
                    display: "flex",
                    marginLeft: "20px",
                  }}
                >
                  {brdCumbPath.map((node) => (
                    <Breadcrumb.Item key={node.id}>
                      {node.Label ||
                        node.label ||
                        node.Organizationname ||
                        node.Projectname ||
                        "NO name"}
                    </Breadcrumb.Item>
                  ))}
                </Typography>
              </Breadcrumb>
            )
          ) : (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
                display: "flex",
                marginLeft: "20px",
              }}
            >
              {brdCumbPath}
            </Typography>
          )}
          {selectedTreeItem === "general" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
                display: "flex",
                marginLeft: "20px",
              }}
            >
              General
            </Typography>
          )}
          {selectedTreeItem === "alert-module" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              {"Alerts  /  Alert Module"}
            </Typography>
          )}
          {selectedTreeItem === "alert-configuration" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              {"Alerts  /  Alert Configuration"}
            </Typography>
          )}
          {selectedTreeItem === "reports" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              Reports
            </Typography>
          )}
          {selectedTreeItem === "system-setup" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              System Setup
            </Typography>
          )}
          {selectedTreeItem === "organisation-setting" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              Organisation Setting
            </Typography>
          )}
          {selectedTreeItem === "compliance" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              {"Modules  /  Compliance"}
            </Typography>
          )}
          {selectedTreeItem === "energy-analytics" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              {"Modules  /  Energy Analytics"}
            </Typography>
          )}
          {selectedTreeItem === "energy-accounting" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              {"Modules  /  Energy Accounting"}
            </Typography>
          )}
          {selectedTreeItem === "power-quality" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              {"Modules  /  Power Quality"}
            </Typography>
          )}
          {selectedTreeItem === "gateways" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              Gateways
            </Typography>
          )}
          {selectedTreeItem === "devices" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              Devices
            </Typography>
          )}
          {selectedTreeItem === "notification" && (
            <Typography
              className="crumbs-config"
              style={{
                fontSize: "14px",
                fontWeight: 400,
                paddingTop: "10px",
              }}
            >
              Notification
            </Typography>
          )}
          {selectedTreeItem === "user-management" && (
            <Typography
              className="crumbs-config"
              style={{ fontSize: "1px", fontWeight: 400, paddingTop: "10px" }}
            >
              User Management
            </Typography>
          )}
        </div>
        {/* <SearchConfig /> */}
      </div>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          height: `calc(100vh - ${pagesize}px)`,
          padding: "0px 16px",
        }}
      >
        <Organizationtree
          orgTree={orgTree}
          callbacktreeselect={handletreeselectcallback}
          callbackTreePath={handleTreePath}
          isLoading={isLoading}
        />
        <Box sx={{ width: "100%", borderRadius: "0px 0px 0px 0px" }}>
          <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
            <Tabs
              value={tabvalue}
              onChange={handletabchange}
              aria-label="basic tabs example"
              sx={{
                "& .MuiTabs-indicator": { display: "none" },
                "& .Mui-selected": {
                  backgroundColor: "var(--SecondaryBackground)",
                  borderRadius: "0px 0px 0px 0px",
                  color: "var(--LK_BrandBlue_1) !important",
                  fontWeight: "700 !important",
                  borderTop: "1px solid var(--HighlightedText_Stroke)",
                  borderLeft: "1px solid var(--HighlightedText_Stroke)",
                  borderRight: "1px solid var(--HighlightedText_Stroke)",
                  borderBottom: "1px solid var(--SecondaryBackground)",
                },
                minHeight: "30px",
                marginBottom: "-1px",
              }}
            >
              {maintabs
                .filter((tab) => {
                  const requiredPermission = tabPermissionMap[tab];
                  return requiredPermission
                    ? userPermissions?.includes(requiredPermission)
                    : true;
                })
                .map((tab) => {
                  return (
                    <Tab
                      sx={{
                        minHeight: "30px",
                        height: "30px",
                      }}
                      style={{
                        color: "var(--GreyVariation_2)",
                        fontFamily: "Roboto",
                        fontSize: "14px",
                        fontWeight: 400,
                        lineHeight: "16.75px",
                        textTransform: "capitalize",
                      }}
                      value={tab}
                      label={tab}
                    >
                      {tab}
                    </Tab>
                  );
                })}
            </Tabs>
          </Box>
          <Box
            sx={{
              width: "100%",
              border: "1px solid var(--HighlightedText_Stroke)",
              height: `calc(100vh - ${pagesize}px)`,
              backgroundColor: "var(--SecondaryBackground)",
            }}
            //  style={{overflow:"auto"}}
          >
            {(tabvalue === "Organization List" ||
              tabvalue === "Organization Details" ||
              tabvalue === "Project Details" ||
              tabvalue === "Project List") && (
              <Box
                sx={{
                  textAlign: "left",
                  height: `calc(100vh - ${pagesize}px)`,
                }}
              >
                <div
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div style={{ flexGrow: 1 }}></div>
                  {/* <button 
                                            style={{
                                                padding: '8px 20px',
                                                //width: '137px',
                                                //height: '35px',
                                                backgroundColor: 'var(--LK_BrandBlue)',
                                                color: 'var(--White)',
                                                //padding: '8px 45px',
                                                border: 'none',
                                                borderRadius: '20px',
                                                fontSize: '16px',
                                                fontWeight: 700,
                                                fontFamily: 'Roboto',
                                                cursor: 'pointer'
                                            }}
                                            disabled= {addneworg ? true : false}
                                            onClick={handleAddnewOrg}
                                        >
                                            Add
                                        </button> */}
                </div>
                <div style={{ height: "calc(100% - 60px)", overflow: "unset" }}>
                  {/* <OrganisationSetting addtrigger= {addneworg} treeselect = {treeselect} callbackedit = {callbackeditorganization}/> */}
                  <OrganisationList
                    selectedTreeNode={treeselect}
                    onAdd={handleAddNode}
                    onDelete={handleDeleteNode}
                    onEdit={handleUpdateNode}
                  />
                </div>
              </Box>
            )}
            {(tabvalue === "Organization User" ||
              tabvalue === "Project User") && (
              <Box
                sx={{
                  textAlign: "left",
                  margin: "10px",
                  height: "calc(100% - 20px)",
                }}
              >
                <div
                  style={{
                    marginTop: "5px",
                    marginBottom: "5px",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div style={{ flexGrow: 1 }}></div>
                  <button
                    style={{
                      padding: "8px 20px",
                      //width: '137px',
                      //height: '35px',
                      backgroundColor: "var(--LK_BrandBlue)",
                      color: "var(--White)",
                      //padding: '8px 45px',
                      border: "none",
                      borderRadius: "20px",
                      fontSize: "16px",
                      fontWeight: 700,
                      fontFamily: "Roboto",
                      cursor: "pointer",
                    }}
                    disabled={addnewuser ? true : false}
                    onClick={handleAddnewOrgUser}
                  >
                    Add
                  </button>
                </div>
                <div
                  style={{
                    height: "calc(100% - 60px)",
                    padding: "10px",
                    overflow: "auto",
                  }}
                >
                  <Userdisplay
                    addtrigger={addnewuser}
                    orgname={userorgname}
                    projname={userprojname}
                    callbackedit={callbackedituser}
                  />
                </div>
              </Box>
            )}

            {tabvalue === "Users List" && (
              <Box
                sx={{
                  textAlign: "left",
                  margin: "10px",
                  height: "calc(100% - 20px)",
                  // overflowY:"scroll"
                }}
              >
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <RoleAccessManagement
                    selectedTreeNode={treeselect}
                    isReadOnly={
                      (userdetails?.User_Role_Details?.Name === "EA_ADMIN" &&
                        treeselect?.Type?.toLowerCase() === "project") ||
                      (userdetails?.User_Role_Details?.Name ===
                        "PROJECT_ADMIN" &&
                        (treeselect?.Type?.toLowerCase() === "organization" ||
                          treeselect?.Type?.toLowerCase() ===
                            "sub-organization"))
                    }
                  />
                </div>
              </Box>
            )}
            {tabvalue === "Roles Management" && (
              <Box
                sx={{
                  textAlign: "left",
                  margin: "10px",
                  height: "calc(100% - 20px)",
                }}
              >
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <RolesManagement
                    selectedTreeNode={treeselect}
                    isReadOnly={
                      userdetails?.User_Role_Details?.Name === "EA_ADMIN" &&
                      treeselect?.Type?.toLowerCase() === "project"
                    }
                  />
                </div>
              </Box>
            )}
            {tabvalue === "Login Policy Settings" && (
              <Box
                sx={{
                  textAlign: "left",
                  margin: "10px",
                  height: "calc(100% - 20px)",
                }}
              >
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <LoginPolicySettings />
                </div>
              </Box>
            )}
            {tabvalue === "Template Group" && (
              <Box
                sx={{
                  textAlign: "left",
                  margin: "10px",
                  height: "calc(100% - 20px)",
                }}
              >
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <TemplateGroup />
                </div>
              </Box>
            )}
            {tabvalue === "Template" && (
              <Box
                sx={{
                  textAlign: "left",
                  margin: "10px",
                  height: "calc(100% - 20px)",
                }}
              >
                <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                  <Template />
                </div>
              </Box>
            )}
          </Box>
        </Box>
        {addneworg && (
          <Box sx={{ width: "300px", marginLeft: "16px" }}>
            <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
              <Tabs
                value={"Add Organization"}
                //onChange={handleChange}
                aria-label="basic tabs example"
                sx={{
                  "& .MuiTabs-indicator": { display: "none" },
                  "& .Mui-selected": {
                    backgroundColor: "var(--SecondaryBackground)",
                    borderRadius: "0px 0px 0px 0px",
                    color: "var(--LK_BrandBlue_1) !important",
                    fontWeight: "700 !important",
                    borderTop: "1px solid var(--HighlightedText_Stroke)",
                    borderLeft: "1px solid var(--HighlightedText_Stroke)",
                    borderRight: "1px solid var(--HighlightedText_Stroke)",
                    borderBottom: "1px solid var(--SecondaryBackground)",
                  },
                  minHeight: "30px",
                  marginBottom: "-1px",
                }}
              >
                <Tab
                  sx={{
                    minHeight: "30px",
                    height: "30px",
                  }}
                  style={{
                    color: "var(--GreyVariation_2)",
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "16.75px",
                    textTransform: "capitalize",
                  }}
                  value={"Add Organization"}
                  label={sidetabtext}
                ></Tab>
              </Tabs>
            </Box>
            <Box
              sx={{
                width: "300px",
                border: "1px solid var(--HighlightedText_Stroke)",
                height: `calc(100vh - ${pagesize}px)`,
                backgroundColor: "var(--SecondaryBackground)",
              }}
            >
              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  marginRight: "5px",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <button
                  style={{
                    padding: "6px 15px",
                    //width: '137px',
                    //height: '35px',
                    backgroundColor: "transparent",
                    color: "var(--GreyBaseColor)",
                    //padding: '8px 45px',
                    border: "1px solid var(--GreyBaseColor)",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={handlecloseaddnew}
                >
                  Close
                </button>
                <button
                  style={{
                    padding: "8px 20px",
                    //width: '137px',
                    //height: '35px',
                    backgroundColor: "var(--LK_BrandBlue)",
                    color: "var(--White)",
                    //padding: '8px 45px',
                    border: "none",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                  }}
                  onClick={handlesaveorg}
                >
                  Save
                </button>
              </div>
              <div style={{ height: "calc(100% - 100px)" }}>
                <AddOrganizationconf
                  savetrigger={saveorgdata}
                  data={orgaddedit}
                  callbacksave={handlesavecallback}
                />
              </div>
            </Box>
          </Box>
        )}
        {adduserfalg && (
          <Box sx={{ width: "300px", marginLeft: "16px" }}>
            <Box sx={{ backgroundColor: "var(--PrimaryBackground)" }}>
              <Tabs
                value={"Add Organization User"}
                //onChange={handleChange}
                aria-label="basic tabs example"
                sx={{
                  "& .MuiTabs-indicator": { display: "none" },
                  "& .Mui-selected": {
                    backgroundColor: "var(--SecondaryBackground)",
                    borderRadius: "0px 0px 0px 0px",
                    color: "var(--LK_BrandBlue_1) !important",
                    fontWeight: "700 !important",
                    borderTop: "1px solid var(--HighlightedText_Stroke)",
                    borderLeft: "1px solid var(--HighlightedText_Stroke)",
                    borderRight: "1px solid var(--HighlightedText_Stroke)",
                    borderBottom: "1px solid var(--SecondaryBackground)",
                  },
                  minHeight: "30px",
                  marginBottom: "-1px",
                }}
              >
                <Tab
                  sx={{
                    minHeight: "30px",
                    height: "30px",
                  }}
                  style={{
                    color: "var(--GreyVariation_2)",
                    fontFamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "16.75px",
                    textTransform: "capitalize",
                  }}
                  value={"Add Organization User"}
                  label={sidetabtextuser}
                ></Tab>
              </Tabs>
            </Box>
            <Box
              sx={{
                width: "300px",
                border: "1px solid var(--HighlightedText_Stroke)",
                height: `calc(100vh - ${pagesize}px)`,
                backgroundColor: "var(--SecondaryBackground)",
              }}
            >
              <div
                style={{
                  marginTop: "10px",
                  marginBottom: "10px",
                  marginRight: "5px",
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div style={{ flexGrow: 1 }}></div>
                <button
                  style={{
                    padding: "6px 15px",
                    //width: '137px',
                    //height: '35px',
                    backgroundColor: "transparent",
                    color: "var(--GreyBaseColor)",
                    //padding: '8px 45px',
                    border: "1px solid var(--GreyBaseColor)",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                  onClick={handlecloseadduser}
                >
                  Close
                </button>
                <button
                  style={{
                    padding: "8px 20px",
                    //width: '137px',
                    //height: '35px',
                    backgroundColor: "var(--LK_BrandBlue)",
                    color: "var(--White)",
                    //padding: '8px 45px',
                    border: "none",
                    borderRadius: "20px",
                    fontSize: "16px",
                    fontWeight: 700,
                    fontFamily: "Roboto",
                    cursor: "pointer",
                  }}
                  onClick={handlesaveusertrigger}
                >
                  Save
                </button>
              </div>
              <div style={{ height: "calc(100% - 100px)" }}>
                <Adduser
                  savetrigger={saveuserdata}
                  data={usereditconf}
                  callbacksave={handleusersavecallback}
                />
              </div>
            </Box>
          </Box>
        )}
        <CustomDialogBox
          dialogTitle={alertState.message}
          openDialog={alertState.show}
          handleConfirmDialog={() =>
            setAlertState((prev) => ({ ...prev, show: false }))
          }
          confirmText={alertState.confirmText || "OK"}
          type={alertState.type}
        />
        {/*<div className="config-main-page">
                    {selectedTreeItem === 'general' && <General />}
                    {selectedTreeItem === 'alert-module' && <AlertModule />}
                    {selectedTreeItem === 'alert-configuration' && <AlertConfiguration />}
                    {selectedTreeItem === 'reports' && <ReportsConfig />}
                    {selectedTreeItem === 'system-setup' && <SystemSetup />}
                    {selectedTreeItem === 'organisation-setting' && <OrganisationSetting />}
                    {selectedTreeItem === 'compliance' && <ComplianceConfiguration />}
                    {selectedTreeItem === 'energy-analytics' && <EnergyAnalyticsConfiguration />}
                    {selectedTreeItem === 'energy-accounting' && <EnergyAccountingConfiguration />}
                    {selectedTreeItem === 'power-quality' && <PowerQualityConfiguration />}
                    {selectedTreeItem === 'gateways' && <Gateways />}
                    {selectedTreeItem === 'devices' && <Devices />}
                    {selectedTreeItem === 'notification' && <Notification />}
                    {selectedTreeItem === 'user-management' && <UserManagement />}
                </div>*/}
      </Box>
    </Box>
  );
}
